export default "__VITE_ASSET__BWi7nv_T__"